function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import _ from 'lodash';
import { DOLLAR_SIGN, POUND_SIGN } from "../constants/consts";
export { default as getApiObjectList } from "./getApiObjectList";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export var showWarningForResidence = function showWarningForResidence(application) {
  // eslint-disable-line @typescript-eslint/no-explicit-any
  try {
    if (application) {
      var northAmerica = ['CA', 'US'];
      var education = application && application.student && application.student.education_summary && application.student.education_summary.education_country;
      var residence = application && application.student && application.student.residential_address && application.student.residential_address.address.country;
      if (education && residence) {
        return _.find(northAmerica, function (x) {
          return x === education;
        }) && !_.find(northAmerica, function (x) {
          return x === residence;
        });
      }
    }
  } catch (err) {
    console.error("There was an error looking at the student's application", err);
  }
  return false;
};
export var ApplicationStatus = /*#__PURE__*/function (ApplicationStatus) {
  ApplicationStatus["RefundInProgress"] = "Refund In Progress";
  ApplicationStatus["DeferralInProgress"] = "Deferral In Progress";
  ApplicationStatus["Withdrawn"] = "Withdrawn";
  ApplicationStatus["Cancelled"] = "Cancelled";
  return ApplicationStatus;
}({});
export var getApplicationStatus = function getApplicationStatus(application) {
  var status = application && application.status || {};
  switch (true) {
    case status.refund_in_progress:
      return ApplicationStatus.RefundInProgress;
    case status.deferral_in_progress:
      return ApplicationStatus.DeferralInProgress;
    case status.withdrawn:
      return ApplicationStatus.Withdrawn;
    case status.canceled:
      return ApplicationStatus.Cancelled;
    default:
      return null;
  }
};
export var AcceptanceStatus = /*#__PURE__*/function (AcceptanceStatus) {
  AcceptanceStatus["Accepted"] = "Accepted";
  AcceptanceStatus["Rejected"] = "Rejected";
  AcceptanceStatus["WaitListed"] = "Waitlisted";
  AcceptanceStatus["ProgramClosed"] = "Program Closed";
  return AcceptanceStatus;
}({});
export var getAcceptanceStatus = function getAcceptanceStatus(application) {
  var status = application && application.status || {};
  if (status.accepted) {
    return AcceptanceStatus.Accepted;
  }
  if (status.rejected) {
    return AcceptanceStatus.Rejected;
  }
  if (status.waitlisted) {
    return AcceptanceStatus.WaitListed;
  }
  if (status.program_closed) {
    return AcceptanceStatus.ProgramClosed;
  }
  return null;
};
export var PaymentStatus = /*#__PURE__*/function (PaymentStatus) {
  PaymentStatus["Paid"] = "Paid";
  PaymentStatus["Unpaid"] = "Unpaid";
  return PaymentStatus;
}({});
export var getPaymentStatus = function getPaymentStatus(application) {
  return application !== null && application !== void 0 && application.paid ? PaymentStatus.Paid : PaymentStatus.Unpaid;
};
export var getApplicationStatusMessage = function getApplicationStatusMessage(application) {
  if (!application) {
    return 'No application provided';
  }
  var acceptanceStatus = getAcceptanceStatus(application);
  if (!acceptanceStatus) {
    var applicationStatus = getApplicationStatus(application);
    if (!applicationStatus) {
      return getPaymentStatus(application).toString();
    }
    return applicationStatus.toString();
  }
  return acceptanceStatus.toString();
};
export var getApplicationDuplicateInfo = function getApplicationDuplicateInfo(_ref) {
  var applicationDuplicates = _ref.applicationDuplicates,
    applicationId = _ref.applicationId,
    applicantId = _ref.applicantId;
  var someDuplicatesExistWithSameUser = applicationDuplicates === null || applicationDuplicates === void 0 ? void 0 : applicationDuplicates.some(function (applicationDuplicated) {
    return applicationDuplicated.applicationId !== applicationId && applicationDuplicated.applicantId === applicantId.toString();
  });
  var someDuplicatesExistWithAnotherUser = applicationDuplicates === null || applicationDuplicates === void 0 ? void 0 : applicationDuplicates.some(function (applicationDuplicated) {
    return applicationDuplicated.applicationId !== applicationId && applicationDuplicated.applicantId !== applicantId.toString();
  });
  return {
    someDuplicatesExistWithAnotherUser: someDuplicatesExistWithAnotherUser,
    someDuplicatesExistWithSameUser: someDuplicatesExistWithSameUser
  };
};

// This is from ab-common
export function toCamelCase(str) {
  return str.split('_').reduce(function (acc, part, index) {
    if (index === 0) {
      return "".concat(part[0].toLowerCase()).concat(part.substring(1));
    }
    return "".concat(acc).concat(part[0].toUpperCase()).concat(part.substring(1));
  }, '');
}

/**
 * @param {string} filename
 * @returns {string}
 */
export function getFileExtensionFromFilename(filename) {
  var pieces = filename.split('.');
  if (pieces.length <= 1) {
    // no extension
    return '';
  }
  var fileExtension = pieces[pieces.length - 1].toLowerCase();
  return fileExtension;
}
export var isAllEmpty = function isAllEmpty(obj) {
  if (obj === undefined || obj === null) {
    return true;
  }
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    var value = obj[keys[i]];
    if (_typeof(value) === 'object' && value !== null) {
      if (!isAllEmpty(value)) {
        return false;
      }
    } else if (value !== null && value !== undefined) {
      return false;
    }
  }
  return true;
};

/** Converts a cents (number) to a string with two decimals */
export var formatCents = function formatCents(cents) {
  var decimalSign = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '.';
  var strCents = String(cents);
  while (strCents.length < 3) {
    strCents = "0".concat(strCents);
  }
  var intPart = strCents.substr(0, strCents.length - 2);
  var decPart = strCents.substr(-2);
  return "".concat(intPart).concat(decimalSign).concat(decPart);
};

/*
 * Returns a sign(dollar/pound) at a given currency.
 */
export var getCurrencySign = function getCurrencySign(currency) {
  if (!currency || typeof currency !== 'string') {
    return;
  }
  var currencyInLower = currency.toLowerCase();
  return currencyInLower === 'gbp' ? POUND_SIGN : DOLLAR_SIGN;
};

// Duplicated from ab-common
export var sortByDateCreated = function sortByDateCreated(noteA, noteB) {
  var a = new Date(noteA.created_at);
  var b = new Date(noteB.created_at);
  return a - b;
};

// Duplicated from ab-common
export var generateNoteLink = function generateNoteLink(note_id) {
  var search = window.location.search;
  var tab = 'notes';
  if (search && search.length > 0) {
    var parts = search.substr(1).split('&');
    var query = parts.reduce(function (response, entry) {
      var pieces = entry.split('=');
      if (pieces.length === 0) {
        response[pieces[0]] = true;
      } else {
        response[pieces[0]] = pieces[1];
      }
      return response;
    }, {});
    if (query.tab && query.tab.length > 0) {
      tab = query.tab;
    }
  }
  var parameters = {
    tab: tab,
    note_id: note_id
  };
  return [window.location.origin, window.location.pathname, '?', Object.keys(parameters).sort().map(function (key) {
    return "".concat(key, "=").concat(parameters[key]);
  }).join('&')].join('');
};
var objects = {};
export var storeObject = function storeObject(key, value) {
  objects[key] = value;
};
export var getObject = function getObject(key) {
  return objects[key];
};

/**
 * Checks wether an ID is a "nanoID" which is the new format we're using for IDs
 * for new APIS.  Instead of an integer, it's a random string of letters,
 * digits, and special characters
 *
 * The method we do this is a little weird because we check the length of the
 * string.  In theory, no integer IDs should contain more than 21 digits.  21
 * digits is a Sextillion.  There's an essentially zero chance any of our
 * database tables will have a Sextillion rows.
 *
 * We could also use isNaN but there's a chance our nanoID algorithm will
 * generate an ID with only digits, which would cause bugs.  Not sure if this
 * chance is higher or lower than the event described above \_(:/)_/
 *
 * This still feels weird and we should find a way to remove this.
 *
 * See this document for more info:
 * https://applyboard.atlassian.net/wiki/spaces/~802237385/pages/2779644346/Thoughts+on+prefixing+IDs
 */
export function isNanoID(id) {
  if (typeof id === 'string' && id.length >= 21) {
    return true;
  }
  return false;
}